import { ICashBox, IRequisite } from '../../../../types'

// export enum RequisiteType {
//   'SBER' = 'SBER',
//   'TINKOFF' = 'TINKOFF',
//   'YOOMONEY' = 'YOOMONEY',
//   'MC/VISA UAH' = 'MC/VISA UAH',
//   'PRIVAT24 P2P UAH' = 'PRIVAT24 P2P UAH',
//   'RAIFFEISEN' = 'RAIFFEISEN',
//   'ALFABANK' = 'ALFABANK',
//   'URALSIB' = 'URALSIB',
//   'VTB' = 'VTB',
//   'VENETS' = 'VENETS',
//   'RSHB' = 'RSHB',
//   'OTP_BANK' = 'OTP_BANK',
//   'GAZPROMBANK' = 'GAZPROMBANK',
//   'PSKB' = 'PSKB',
// }

export enum Currency {
  RUB = 'RUB',
  UAH = 'UAH',
  AZN = 'AZN',
  KZT = 'KZT',
  KRW = 'KRW',
  EUR = 'EUR',
  USD = 'USD',
  NOT_TON = 'NOT(TON)',
  USDC_ETH = 'USDC(ETH)',
  ETH = 'ETH(ETH)',
  USDT_TRX = 'USDT(TRX)',
  USDT_TON = 'USDT(TON)',
  TON = 'TON(TON)',
  LTC = 'LTC(LTC)',
  BTC = 'BTC(BTC)',
  HMSTR = 'HMSTR(TON)',
  DOGE = 'DOGE(DOGE)',
}

export interface ErrorObject {
  cashBoxId: string
  requisiteType: string
  cardNumber: string
  phone: string
  cardholderName: string
  comment: string
  paymentLimitByAmount: string
  general_error: string
  commission: string
}

export interface RequisiteListResponse {
  success: boolean
  requisites: Array<IRequisite>
  totalRows: number
  errors: Partial<ErrorObject>
}

export interface RequisiteEdit {
  id?: number
  accountNumber?: string | null
  cashBox: ICashBox
  cashBoxId: number | string
  requisiteType: string
  name: string
  phone?: string | null
  cardNumber: string | null
  cardholderName: string | null
  currency?: Currency
  paymentLimitByAmount: number
  paymentLimitByTicketCount: number
  paymentMethods: string[]
  comment: string
  paymentUrl?: string
  acquiringBank: string | null
  minDeposit?: number | string
  maxDeposit?: number | string
  fastTrackEnabled?: boolean
  fastTrackMaxClients?: number
}

export interface RequisiteEditResponse {
  success: boolean
  requisite: IRequisite
  totalRows: number
  errors: Partial<ErrorObject>
}

export interface RequisiteTotalSumResponse {
  sum: number
  totalRows: number
  success: boolean
  errors: Partial<ErrorObject>
}

export interface RequisiteToggleResponse {
  success: boolean
  requisite: IRequisite
  totalRows: number
  errors: Partial<ErrorObject>
}
